import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";

const HEADER_FILL = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFB9D1EA" },
};

const COLUMN_HEADER_FILL = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFD9D9D9" },
};

const THIN_BLACK = {
  top: { style: "thin", color: { argb: "FF000000" } },
  left: { style: "thin", color: { argb: "FF000000" } },
  bottom: { style: "thin", color: { argb: "FF000000" } },
  right: { style: "thin", color: { argb: "FF000000" } },
};

const BODY_FONT = { name: "Calibri", size: 11 };

const COL_START = 4; // D
const COL_END = 8; // H
const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

function borderCell(cell) {
  cell.border = THIN_BLACK;
}

function setCell(ws, row, col, value, options = {}) {
  const cell = ws.getCell(row, col);
  cell.value = value;
  cell.font = options.bold ? { ...BODY_FONT, bold: true } : BODY_FONT;
  borderCell(cell);
  cell.alignment = {
    horizontal: options.align || "center",
    vertical: "middle",
    wrapText: true,
  };
  if (options.fill) cell.fill = options.fill;
}

function formatSharePct(value) {
  if (value === null || value === undefined || value === "") return "";
  const str = String(value).trim();
  if (str.endsWith("%")) return str;
  const num = Number(value);
  if (Number.isNaN(num)) return str;
  return `${num.toFixed(2)}%`;
}

function formatYesNo(value) {
  if (value === true || String(value).toLowerCase() === "yes") return "Yes";
  if (value === false || String(value).toLowerCase() === "no") return "No";
  if (value === null || value === undefined || value === "") return "";
  return String(value);
}

export function buildHoldingSubsidiaryAssociateSheet(workbook, sectionA) {
  const ws = workbook.addWorksheet("Holding,subsidiary or associate", {
    views: [{ showGridLines: true }],
  });

  const widths = { A: 2, B: 2, C: 2, D: 8, E: 28, F: 24, G: 16, H: 22 };
  Object.entries(widths).forEach(([col, width]) => {
    ws.getColumn(col).width = width;
  });

  addSheetBackLink(ws, PARENT_SHEETS.GENERAL_DISCLOSURES, { mergeEnd: COL_END });

  const companies = sectionA?.holding?.associatedCompaniesAndCsr || [];

  ws.mergeCells(TITLE_ROW, COL_START, TITLE_ROW, COL_END);
  const tableTitle = ws.getCell(TITLE_ROW, COL_START);
  tableTitle.value =
    "Holding, Subsidiary and Associate Companies (including joint ventures)";
  tableTitle.font = { ...BODY_FONT, bold: true };
  tableTitle.fill = HEADER_FILL;
  borderCell(tableTitle);
  tableTitle.alignment = { horizontal: "center", vertical: "middle", wrapText: true };

  const headers = [
    { col: COL_START, label: "Sr. No." },
    {
      col: 5,
      label:
        "Name of the holding / subsidiary/associate companies/joint ventures (A)",
    },
    {
      col: 6,
      label: "Indicate whether holding/Subsidiary/Associate /Joint Venture",
    },
    { col: 7, label: "% of shares held by listed entity" },
    {
      col: COL_END,
      label:
        "Does the entity indicated at column A, participate in the Business Responsibility initiatives of the listed entity? (Yes/No)",
    },
  ];

  headers.forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, { bold: true, fill: COLUMN_HEADER_FILL, align: "center" });
  });

  const rows = companies.length ? companies : [{}];

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_START, String(idx + 1), { align: "center" });
    setCell(ws, row, 5, item?.name ?? "", { align: "left" });
    setCell(ws, row, 6, item?.relationType ?? "", { align: "left" });
    setCell(ws, row, 7, formatSharePct(item?.sharePercentage), { align: "right" });
    setCell(ws, row, COL_END, formatYesNo(item?.participatesInBR), { align: "center" });
  });

  return ws;
}
